import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export type KeySectionProps = { id: string };

export const keySection: BaseKeyFunction<KeySectionProps> = ({ id }) => [
  "sections",
  id,
];
